// eslint-disable-next-line import/no-anonymous-default-export
export default {

    
    baseUrl:"https://24ur.devssh.xyz/",
    // baseUrl:"http://192.168.114.13:8004/",


    imgUrl:"https://24ur.devssh.xyz",

    BaseUrlVariable:"https://24ur.devssh.xyz/subadmin",

    UserBaseUrl: "https://24ur.devssh.xyz/user"
    // UserBaseUrl: "http://192.168.114.13:8004/user"

    
    
    
  

}
